import { useNavigate } from 'react-router-dom'
import { useEffect } from "react"
import axios from 'axios'

function Logout() {
    const navigate = useNavigate()
    const email = localStorage.getItem('email')

    const logout = async () => {
        try {
            axios.defaults.withCredentials = true
            const response = await axios.post(`/logout/${email}`)
        } catch (err) { console.error(err) }
    }

    useEffect(() => {
        logout()
        const valoreSalvato = localStorage.getItem('idUser')
        localStorage.clear()
        localStorage.setItem('idUser',valoreSalvato)
        navigate('/', { replace: true })
    })
    return (<></>)
}
export default Logout